import type { Timesheet } from '@/types/timesheet';

// Helper function to calculate timesheet total hours
export const calculateTimesheetTotal = (timesheet: Timesheet) => {
  return timesheet.entries.reduce((sum, entry) => {
    return sum + Object.values(entry.hours).reduce((h, v) => h + v, 0);
  }, 0);
};
